"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.fill");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/web.dom.iterable");
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _ChangTime = _interopRequireDefault(require("./ChangTime.vue"));
var _index = _interopRequireDefault(require("@/components/Store/AddEditStoreModel/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _timeConflit = _interopRequireDefault(require("../mixins/timeConflit"));
var _utils = require("@/components/Store/utils");
var _index3 = require("../statics/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** mixins */
/** utils */
/** statics */
// 类型 ，计划、任务，由前端自行维护
var _default2 = exports.default = {
  components: {
    ChangTime: _ChangTime.default,
    AddEditStoreModel: _index.default,
    RangePick: _index2.default
  },
  mixins: [_myform.default, _timeConflit.default],
  props: {
    // 左侧table选中的date具体信息
    actDateinfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 所有下拉options配置
    /**
     * optConfig.visitPurposeOptions: [], // 拜访目的select
     * optConfig.rtmOptions: [], // 门店RTM类型select
     * optConfig.storeCategoryOptions: [], // 客户类型select（零售店类别）
     * optConfig.tppOptions: [], // TPP签约量select
     * optConfig.storeStructureOptions: [], // 零售店性质select
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     * optConfig.daMethodOptions: [], // 记账方式select
     * optConfig.tireSupplierOptions: [], // 主要进货渠道select
     * optConfig.accountMethodOptions: [], // 结算方式select
     * optConfig.tyreBrandOptions: [], // 轮胎品牌select
     * optConfig.mainserviceOptions: [], // 主要服务项目select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var defaultForm = {
      planTaskStartTime: '',
      planTaskEndTime: ''
    };
    var default_SearchForm = {
      storeName: '',
      // 门店名称
      storeCode: '',
      // 门店编号
      contactor: '',
      // 门店联系人
      tppGySign: '',
      // 固特异TPP签约量
      PCD: [],
      // 省市区 不传后端
      region: '',
      // 省label
      regionCode: '',
      // 省
      city: '',
      // 市label
      cityCode: '',
      // 市
      district: '',
      // 区label
      districtCode: '',
      // 区
      storeAddress: '',
      // 门店地址
      retailerType: '',
      // 店面级别（零售店类别）
      rtlRtmCategory: '',
      // 客户类型(零售店RTM类型)
      isBaiLian: ''
    };
    return {
      PT_STATUS_PLAN: _index3.PT_STATUS_PLAN,
      // 计划
      PT_STATUS_TASK: _index3.PT_STATUS_TASK,
      // 任务
      actualPlanTaskFlag: '',
      // Y:实际任务；N:计划任务
      /** form group */
      formLabelWidth: '120px',
      isShowModel: false,
      // visible
      dialogStatus: 'create',
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      regionProps: {
        expandTrigger: 'hover',
        checkStrictly: true
      },
      form: Object.assign({}, defaultForm),
      initForm: Object.assign({}, defaultForm),
      taskForm: {
        visitPurpose1: '',
        // 拜访目的1
        visitPurpose2: '',
        // 拜访目的2
        remark: '' // 拜访目的的简要说明
      },
      rules: {
        validateIpt: [{
          required: true,
          trigger: ['blur'],
          message: this.$t('errorValid.empty')
        }],
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      },
      /** search + table */
      searchForm: Object.assign({}, default_SearchForm),
      table: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        // api timer
        storeChecked: [],
        // 访店计划流程 store info array
        taskStoreChecked: {} // 访店任务流程 store info
      },
      /** other */
      canSubmit: true,
      /** 时间分割弹窗数据 */
      changeTime: {
        visible: false,
        // 是否显示时间分割弹窗
        storelist: [] // 需要变更时间的列表
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return "".concat(this.dialogStatus === 'edit' ? this.$t('common.edit') : this.$t('common.create')).concat(this.$t('doubleWeekPlan.title.storeToVisit'), "\uFF1A").concat(this.actDateinfo.planTaskDateStr || '');
    },
    startOptions: function startOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        maxTime: this.form.planTaskEndTime
      });
    },
    endOptions: function endOptions() {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pickerOptions), {}, {
        minTime: this.form.planTaskStartTime
      });
    },
    // 是创建任务流程
    isTask: function isTask() {
      return this.actualPlanTaskFlag === _index3.PT_STATUS_TASK;
    }
  },
  watch: {
    isShowModel: {
      handler: function handler(val, old) {
        if (val !== old && !val) {
          this.resetModel();
        }
      }
    }
  },
  methods: {
    // open dialog init
    init: function init(type) {
      // 没有选中日期不能操作
      if (!this.actDateinfo.planTaskDate) {
        return false;
      }
      this.isShowModel = true;
      this.actualPlanTaskFlag = type;
      // 根据ba描述，目前门店计划没编辑
      this.queryList();
    },
    // get table list
    queryList: function queryList() {
      var _this = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({}, others)
      };
      this.table.listLoading = true;
      (0, _doubleWeekPlan.getPlanStoreList)(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res || {},
          data = _ref.data;
        var _ref2 = data || {},
          _ref2$items = _ref2.items,
          items = _ref2$items === void 0 ? [] : _ref2$items,
          _ref2$totalCount = _ref2.totalCount,
          totalCount = _ref2$totalCount === void 0 ? 0 : _ref2$totalCount;
        _this.table.list = items;
        _this.table.total = totalCount;
        // 在新增计划模式下，切换列表需要重置选中项目
        if (_this.actualPlanTaskFlag === _index3.PT_STATUS_PLAN) {
          _this.$nextTick(function () {
            var storeCodes = _this.table.storeChecked.map(function (i) {
              return i.storeCode;
            });
            // this.$refs.table.toggleRowSelection(this.lists[i],true)
            if (storeCodes.length > 0) {
              _this.table.list.forEach(function (items, index) {
                if (storeCodes.indexOf(items.storeCode) >= 0) {
                  _this.$refs.table.toggleRowSelection(items, true);
                }
              });
            }
          });
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this.table.listLoading = false;
      });
    },
    // search table
    searchData: function searchData() {
      // console.log(999, this.searchForm)
      this.table.currPage = 1;
      this.queryList();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchForm = data.searchForm;
      this.searchData();
    },
    // store checked event
    handleStoreChecked: function handleStoreChecked(rows) {
      // console.log(999, rows)
      if (this.table.listLoading) {
        return false;
      }
      // 当前页选中
      var checkedCodes = rows.map(function (i) {
        return i.storeCode;
      });
      // 当前页取消选中
      var unCheckedRows = this.table.list.filter(function (i) {
        return checkedCodes.indexOf(i.storeCode) < 0;
      });
      var unCheckedCodes = unCheckedRows.map(function (i) {
        return i.storeCode;
      });
      var rowsMap = new Map();
      this.table.storeChecked.concat(rows).forEach(function (i) {
        rowsMap.set(i.storeCode, i);
      });
      var arr = Array.from(rowsMap.values()).filter(function (i) {
        return unCheckedCodes.indexOf(i.storeCode) < 0;
      });
      this.table.storeChecked = arr;
    },
    // 新开卡（新增门店）
    onAddStore: function onAddStore() {
      this.$refs['addEditStoreModel'].init();
    },
    // 取消按钮前置操作
    onBeforeCancel: function onBeforeCancel() {
      if (this.changeTime.visible) {
        // 时间分割step特殊处理
        this.clearChangeTime();
        return false;
      } else {
        // 默认执行cancel方法
        return true;
      }
    },
    // 保存
    saveItem: function () {
      var _saveItem = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var status, params;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.changeTime.visible) {
                _context.n = 3;
                break;
              }
              _context.n = 1;
              return this.$refs['changeTimeRef'].checkIpt();
            case 1:
              status = _context.v;
              if (status) {
                _context.n = 2;
                break;
              }
              return _context.a(2, false);
            case 2:
              // 新增门店计划，拆分时间后保存（step2）
              params = {
                actualPlanTaskFlag: this.actualPlanTaskFlag,
                planTaskDate: this.actDateinfo.planTaskDate || '',
                planTaskType: 'A01',
                // 客户拜访固定类型
                detailList: this.changeTime.storelist
              };
              this.api_save(params, true);
              _context.n = 4;
              break;
            case 3:
              if (this.actualPlanTaskFlag === _index3.PT_STATUS_PLAN) {
                // 计划
                this.savePlanItem();
              } else {
                // 任务
                this.saveTaskItem();
              }
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function saveItem() {
        return _saveItem.apply(this, arguments);
      }
      return saveItem;
    }(),
    /**
     * 计划
     */
    // 保存计划
    savePlanItem: function savePlanItem() {
      var _this2 = this;
      // console.log(1111, this.table.storeChecked.map(i => i.storeCode))
      if (this.table.storeChecked.length <= 0) {
        this.$message.warning(this.$t('doubleWeekPlan.error.storeChecked'));
        return false;
      }
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) {
          _this2.$message.error(_this2.$t('doubleWeekPlan.error.planRangeTime'));
          return;
        }

        // 自行分割时间并保存
        _this2.changeTime.visible = true;
        _this2.getChangeTimeClip(_this2.table.storeChecked, _this2.form.planTaskStartTime, _this2.form.planTaskEndTime);

        // // 重复触发
        // if (!this.canSubmit) {
        //   return false
        // }
        // this.canSubmit = false

        // // 获取时间区间分割params
        // const prevParams = {
        //   planTaskDate: this.actDateinfo.planTaskDate || '',
        //   planTaskStartTime: this.form.planTaskStartTime,
        //   planTaskEndTime: this.form.planTaskEndTime,
        //   storeCodeList: this.table.storeChecked.map(i => i.storeCode)
        // }
        // // 获取时间区间分割
        // getAllocateTime(prevParams)
        //   .then(prevRes => {
        //     const { data = [] } = prevRes || {}
        //     // 自行分割时间并保存
        //     this.changeTime.visible = true
        //     // this.changeTime.storelist = data
        //     this.getChangeTimeClip(data, prevParams.planTaskStartTime, prevParams.planTaskEndTime)
        //   })
        //   .finally(() => {
        //     this.canSubmit = true
        //   })
      });
    },
    /**
     * 分割时间
     */
    getChangeTimeClip: function getChangeTimeClip(data, startTxt, endTxt) {
      var diff = 30; // 每个片段占据的时长
      var start = (0, _utils.getTimenums)(startTxt);
      var end = (0, _utils.getTimenums)(endTxt);
      var targetLen = data.length; // 需要拆分给对应的门店数
      var totalLen = Math.ceil((end - start) / diff); // 因为有23:59的特殊情况，需要取整
      var avaClip = Math.floor(totalLen / targetLen); // 最小平均值
      var lClip = totalLen % targetLen; // 余数
      // 需要添加的时间片数量
      var arr = Array(targetLen).fill(avaClip);
      if (avaClip === 0) {
        // 正叙加
        arr = arr.map(function (i) {
          var clip = i;
          if (lClip > 0) {
            clip++;
            lClip--;
          }
          return clip;
        });
      } else {
        // 倒叙加
        arr = arr.reverse().map(function (i) {
          var clip = i;
          if (lClip > 0) {
            clip++;
            lClip--;
          }
          return clip;
        }).reverse();
      }
      // 开始拆分
      var curStart = start;
      // const oldList = this.changeTime.storelist
      // this.changeTime.storelist.splice(0, oldList.length, ...data.map((item, index) => {
      //   const actDiff = diff * arr[index]
      //   if (actDiff === 0) {
      //     // 没分时间
      //     // 赋值
      //     item.planTaskStartTime = ''
      //     item.planTaskEndTime = ''
      //   } else {
      //     // 分了时间
      //     let curEnd = curStart + diff * arr[index]
      //     // 针对23:59格式化
      //     if (curEnd > end) {
      //       curEnd = end
      //     }
      //     // 赋值
      //     item.planTaskStartTime = getTimeStr(curStart)
      //     item.planTaskEndTime = getTimeStr(curEnd)
      //     // 余数减少
      //     lClip--
      //     curStart = curEnd
      //   }
      //   return item
      // }))
      this.changeTime.storelist = (0, _toConsumableArray2.default)(data.map(function (item, index) {
        var actDiff = diff * arr[index];
        if (actDiff === 0) {
          // 没分时间
          // 赋值
          item.planTaskStartTime = '';
          item.planTaskEndTime = '';
        } else {
          // 分了时间
          var curEnd = curStart + diff * arr[index];
          // 针对23:59格式化
          if (curEnd > end) {
            curEnd = end;
          }
          // 赋值
          item.planTaskStartTime = (0, _utils.getTimeStr)(curStart);
          item.planTaskEndTime = (0, _utils.getTimeStr)(curEnd);
          // 余数减少
          lClip--;
          curStart = curEnd;
        }
        return item;
      }));
    },
    /**
     * 任务
     */
    // 任务 单选
    getCurrentRow: function getCurrentRow(row) {
      this.table.taskStoreChecked = Object.assign({}, row);
    },
    // 保存任务
    saveTaskItem: function () {
      var _saveTaskItem = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var valid1, valid2, params;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.table.taskStoreChecked.storeCode) {
                _context2.n = 1;
                break;
              }
              this.$message.warning(this.$t('doubleWeekPlan.error.storeChecked'));
              return _context2.a(2, false);
            case 1:
              this.$refs['dataForm'].clearValidate();
              this.$refs['taskForm'].clearValidate();
              _context2.n = 2;
              return this.$refs['dataForm'].validate().catch(function (err) {
                return err;
              });
            case 2:
              valid1 = _context2.v;
              _context2.n = 3;
              return this.$refs['taskForm'].validate().catch(function (err) {
                return err;
              });
            case 3:
              valid2 = _context2.v;
              if (!(valid1 !== true || valid2 !== true)) {
                _context2.n = 4;
                break;
              }
              if (valid1 !== true) {
                this.$message.error(this.$t('doubleWeekPlan.error.planRangeTime'));
              } else if (valid2 !== true) {
                this.$message.error(this.$t('doubleWeekPlan.error.taskTarget'));
              }
              return _context2.a(2);
            case 4:
              if (this.canSubmit) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2, false);
            case 5:
              this.canSubmit = false;
              params = {
                actualPlanTaskFlag: this.actualPlanTaskFlag,
                planTaskDate: this.actDateinfo.planTaskDate || '',
                planTaskType: 'A01',
                // 客户拜访固定类型
                detailList: [(0, _objectSpread2.default)((0, _objectSpread2.default)({
                  planTaskStartTime: this.form.planTaskStartTime,
                  planTaskEndTime: this.form.planTaskEndTime
                }, this.table.taskStoreChecked), this.taskForm)]
              }; // 实际保存
              this.api_save(params);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveTaskItem() {
        return _saveTaskItem.apply(this, arguments);
      }
      return saveTaskItem;
    }(),
    // api 保存方法 , 针对 step2拆分时间后保存的报错定制展示形式
    api_save: function api_save(params, isStep2) {
      var _this3 = this;
      (0, _doubleWeekPlan.savePlanTask)(params).then(function () {
        _this3.$message({
          message: _this3.$t('common.saveSuccess'),
          type: 'success'
        });
        _this3.$emit('refresh');
        _this3.isShowModel = false;
      }).catch(function (err) {
        if (isStep2) {
          // 在changeTime组件内反馈
          _this3.$refs['changeTimeRef'].errHandle(err);
        } else {
          // 在当前组件内反馈
          _this3.errorHandle(err, 'dataForm');
        }
        // 如果是时间冲突了，则弹出冲突弹窗
        var _params$detailList = params.detailList,
          detailList = _params$detailList === void 0 ? [] : _params$detailList,
          actualPlanTaskFlag = params.actualPlanTaskFlag,
          planTaskDate = params.planTaskDate;
        var conflitParams = {
          actualPlanTaskFlag: actualPlanTaskFlag,
          planTaskDate: planTaskDate,
          timeList: detailList.map(function (i) {
            return {
              startTime: i.planTaskStartTime,
              endTime: i.planTaskEndTime
            };
          })
        };
        _this3.timeConflitHandle(err.errorInfos, conflitParams);
      }).finally(function () {
        _this3.canSubmit = true;
      });
    },
    // 重置弹窗
    resetModel: function resetModel() {
      this.canSubmit = true;
      this.clearForm();
      this.clearTable();
      this.clearChangeTime();
    },
    // reset form
    clearForm: function clearForm() {
      console.log('clear form');
      try {
        var dataFormDom = this.$refs['dataForm'];
        var searchFormDom = this.$refs['searchForm'];
        dataFormDom && dataFormDom.resetFields();
        searchFormDom && searchFormDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.form = data.form;
      this.initForm = data.initForm;
      this.searchForm = data.searchForm;
      this.taskForm = data.taskForm;
    },
    clearTable: function clearTable() {
      var data = this.$options.data.call(this);
      this.table = data.table;
    },
    // 重置时间分割弹窗
    clearChangeTime: function clearChangeTime() {
      try {
        var changeTimeDom = this.$refs['changeTimeRef'];
        changeTimeDom && changeTimeDom.resetFields();
      } catch (error) {
        console.log(error);
      }
      var data = this.$options.data.call(this);
      this.changeTime = data.changeTime;
    }
  }
};